module.exports = __webpack_public_path__ + "img/about4.ecd8d3a.png";